import EcoImg from 'eco-design/base/eco-img';
import style from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EfSection from '@elem/ui/ef-section';
import { useLang } from '@/i18n';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoVideo from 'eco-design/base/eco-video';
import { useRouter } from 'next/router';
import { getIsMobileWidth } from '@elem/utils/devices';

const E: React.FC = () => {
    const { t } = useLang('powerBank.E');
    const { locale = 'us' } = useRouter();
    const isMobile = getIsMobileWidth() || false; //是否是移动端
    return (
        <div className={`${style.comp} E Rapid-E eco-content GtmModuleData-section`} data-section-id="Rapid-E">
            <EcoSpace />
            <EfSection title={t('title')} />
            <EcoSpaceSmall />
            <div className="cart-box cart-box-pc">
                <div className="cart-box-1">
                    <div className="box-1-item">
                        <EcoVideo
                            pc={'https://websiteoss.ecoflow.com/upload/video/1748590941410/%E6%80%A7%E4%BB%B7%E6%AF%94%E5%AE%98%E7%BD%91-xcore-pc_1.mp4'}
                            h5={'https://websiteoss.ecoflow.com/upload/video/1748590941235/%E6%80%A7%E4%BB%B7%E6%AF%94%E5%AE%98%E7%BD%91-xcore-mob_1.mp4'}
                            poster={'https://websiteoss.ecoflow.com/upload/image/1748590947763/Frame%201612689911.jpg'}
                            posterH5={'https://websiteoss.ecoflow.com/upload/image/1748590947571/Frame%201000009270.jpg'}
                            autoPlay={true}
                            loop={true}
                        />
                    </div>
                    <div className="box-1-msg">
                        <div className="box-1-msg-icon">
                            <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1743756373630/X-core.png"></EcoImg>
                        </div>
                        <p>{t('item1_text')}</p>
                    </div>
                </div>
                <div className="cart-box-2">
                    <div className="box-2-item-l box-2-item">
                        <EcoImg
                            isOpenLazy
                            pc={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1762508748975/pc%202-1.jpg'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1750054594363/Frame%201612689863.jpg'
                            }
                        ></EcoImg>
                        <div className="box-2-msg">
                            <p className="msg-1">{t('item2_text1')}</p>
                            <p className="msg-2">{t('item2_text2')}</p>
                        </div>
                    </div>
                    <div className="box-2-item-m box-2-item">
                        <EcoImg
                            isOpenLazy
                            pc={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1762508748570/pc%202-2.jpg'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1747968475555/Frame%201612689870.jpg'
                            }
                        ></EcoImg>
                        <div className="box-2-msg">
                            <p className="msg-1">
                                {locale !== 'jp' ? (
                                    t('item3_text1')
                                ) : (
                                    <span className="box-2-item-m-img">
                                        <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1750315530621/X-stream%201.svg"></EcoImg>
                                    </span>
                                )}
                            </p>
                            <p className="msg-2">{t('item3_text2')}</p>
                            <p className="msg-3">{t('item3_text3')}</p>
                        </div>
                    </div>
                    {locale !== 'ph' && (
                        <div className="box-2-item-r box-2-item">
                            <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1747968475746/Frame%201612689875.jpg"></EcoImg>
                            <div className="box-2-msg">
                                <p className="msg-1">{t('item4_text1')}</p>
                                <p className="msg-2">{t('item4_text2')}</p>
                            </div>
                        </div>
                    )}
                </div>
                <div className="cart-box-3">
                    <div className="box-3-item box-3-item-l">
                        <EcoImg
                            isOpenLazy
                            pc={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1762508748258/pc%203-1.jpg'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1753258833440/Frame%201612689873.jpg'
                            }
                        ></EcoImg>
                        <div className="box-3-msg">
                            <p className="msg-1">{t('item5_text1')}</p>
                            <p className="msg-2">
                                {t.rich('item5_text2', {
                                    b: (text: string) => {
                                        return <span className="blog">{text}</span>;
                                    },
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="box-3-item box-3-item-r">
                        <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1753258745540/PC-%E7%94%B5%E6%B1%A0.jpg"></EcoImg>
                        <div className="box-3-msg">
                            <p className="msg-1">{t('item6_text1')}</p>
                            <p className="msg-2">{t('item6_text2')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cart-box cart-box-h5">
                <div className="cart-box-1">
                    <div className="box-1-item">
                        <EcoVideo
                            pc={'https://websiteoss.ecoflow.com/upload/video/1748590941235/%E6%80%A7%E4%BB%B7%E6%AF%94%E5%AE%98%E7%BD%91-xcore-mob_1.mp4'}
                            poster={'https://websiteoss.ecoflow.com/upload/image/1748590947571/Frame%201000009270.jpg'}
                            autoPlay={true}
                            loop={true}
                        />
                    </div>
                    <div className="box-1-msg">
                        <div className="box-1-msg-icon">
                            <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1743756373630/X-core.png"></EcoImg>
                        </div>
                        <p>{locale === 'jp' ? t('item1_text_h5') : t('item1_text')}</p>
                    </div>
                </div>
                <div className="cart-box-2">
                    <EcoImg
                        isOpenLazy
                        pc={
                            locale === 'ph'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1762508747922/m%202-1.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1750074031361/Frame%201000009271.jpg'
                        }
                    ></EcoImg>
                    <div className="box-2-msg">
                        <p className="msg-1">
                            {locale !== 'jp' ? (
                                t('item3_text1')
                            ) : (
                                <span className="box-2-item-m-img">
                                    <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1750315530621/X-stream%201.svg"></EcoImg>
                                </span>
                            )}
                        </p>
                        <p className="msg-2">{t('item3_text2')}</p>
                        <p className="msg-3">{t('item3_text3')}</p>
                    </div>
                </div>
                <div className="cart-box-3">
                    <div className="cart-box-3-l">
                        <div className="box-3-item-1 box-3-item">
                            <EcoImg
                                isOpenLazy
                                pc={
                                    locale === 'ph'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1762509338873/m%203-1.jpg'
                                        : 'https://websiteoss.ecoflow.com/upload/image/1747970845662/Frame%20161269802.jpg'
                                }
                            ></EcoImg>
                            <div className="box-3-msg">
                                <p className="msg-1">{t('item4_text1')}</p>
                                <p className="msg-2">{t('item4_text2')}</p>
                            </div>
                        </div>
                        <div className="box-3-item box-3-item-2">
                            <EcoImg
                                isOpenLazy
                                pc={
                                    locale === 'ph'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1762508749368/m3-2.jpg'
                                        : 'https://websiteoss.ecoflow.com/upload/image/1753258833945/Frame%20161269804.jpg'
                                }
                            ></EcoImg>
                            <div className="box-3-msg">
                                <p className="msg-1">{t('item5_text1')}</p>
                                <p className="msg-2">
                                    {t.rich('item5_text2', {
                                        b: (text: string) => {
                                            return <span className="blog">{text}</span>;
                                        },
                                    })}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="box-3-item-r">
                        <EcoImg
                            isOpenLazy
                            pc={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1762508747594/Frame%20161269803.jpg'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1750054594184/Frame%20161269803.jpg'
                            }
                        ></EcoImg>
                        <div className="box-3-msg">
                            <p className="msg-1">{t('item2_text1')}</p>
                            <p className="msg-2">{t('item2_text2')}</p>
                        </div>
                    </div>
                </div>
                {locale !== 'ph' && (
                    <div className="cart-box-4">
                        <div className="box-4-item">
                            <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1753258745502/M-%E7%94%B5%E6%B1%A0.jpg"></EcoImg>
                            <div className="box-4-msg">
                                <p className="msg-1">{t('item6_text1')}</p>
                                <p className="msg-2">{t('item6_text2')}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <EcoSpace />
        </div>
    );
};
export default E;
